var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAgreementsIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Agreements_Icon",
    "data-name": "Agreements Icon",
    transform: "translate(-26 -242)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Agreements_Icon-2",
    "data-name": "Agreements Icon",
    width: 24,
    height: 24,
    transform: "translate(26 242)",
    fill: "#ececec",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-md-checkbox-outline",
    "data-name": "Icon ionic-md-checkbox-outline",
    d: "M9.4,11.6,8,13l4.5,4.5,10-10L21.1,6.1l-8.6,8.55Zm11.1,8.9H6.5V6.5h10v-2H6.5a2.006,2.006,0,0,0-2,2v14a2.006,2.006,0,0,0,2,2h14a2.006,2.006,0,0,0,2-2v-8h-2Z",
    transform: "translate(24.5 240.5)",
    fill: "#69747a"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgreementsIcon);
export default __webpack_public_path__ + "static/media/Agreements_Icon.cfbe5fcab8ab45e9639ffb47e86f4722.svg";
export { ForwardRef as ReactComponent };